import 'jquery';

//header scrolling
$(function(){
	'use strict';
	$(window).scroll(function(){
		if($(this).scrollTop()>1){
			$('html').addClass('scrolling');
		} else {
			$('html').removeClass('scrolling');
		}
	});
});

//gotop
$(function(){
	'use strict';
  var t1 = 0;
  var t2 = 0;
  var timer = null;
  
	$(window).scroll(function(){
    clearTimeout(timer);
    timer = setTimeout(isScrollEnd, 2000);
    t1 = document.documentElement.scrollTop || document.body.scrollTop;
    
		if($(this).scrollTop()>1){
			$('.gotop').css({bottom:'85px'});
		} else {
			$('.gotop').css({bottom:'-100px'});
		}
	});
    
  function isScrollEnd() {
    t2 = document.documentElement.scrollTop || document.body.scrollTop;
    if(t2 == t1){
			$('.gotop').css({bottom:'-100px'});
    }
  }
  
	$('.gotop').click(function(){
		$('html, body').animate({scrollTop:'0px'},500);return false;
	});
});

//for pre-calculation result
$(function(){
	'use strict';
  var footer =  $('#footer');
	var fixedBottom = $('#fixed-bottom-box');
  var entranceFooterBox =  $('.wrapper-entrance #footer > .box');
	var entranceFixedBottomBox = $('.wrapper-entrance #fixed-bottom-box > .box');
  var footerBoxH =  $('#footer > .box').height();
	var fixedBottomBoxH = $('#fixed-bottom-box > .box').height();
  var resizeTimer = null;
  
  fixedBottom.css('height',fixedBottomBoxH);
  footer.css('height',footerBoxH+1);
  
  $(window).resize(function (){
    if(resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function(){
      fixedBottom.css('height',fixedBottomBoxH);
      footer.css('height',footerBoxH+1);
      
      fixedBottomBoxH = $('#fixed-bottom-box > .box').height();
      footerBoxH =  $('#footer > .box').height();
    });
  });
  
  function mainBoxH() {
    if($(window).innerWidth() < 767){
      $('.main > .box').css('min-height', ("calc(100vh - 95px - {footerBoxH}px - 1px)").replace("{footerBoxH}", footerBoxH));
    }else if($(window).innerWidth() > 768 && $(window).innerWidth() < 991){
      $('.main > .box').css('min-height', ("calc(100vh - 95px - 40px - {footerBoxH}px - 1px)").replace("{footerBoxH}", footerBoxH));
      $('.wrapper-category .main > .box').css('min-height', ("calc(100vh - 95px - 11.496vw - {footerBoxH}px - 1px)").replace("{footerBoxH}", footerBoxH));
    }else if($(window).innerWidth() > 992 && $(window).innerWidth() < 1199){
      $('.main > .box').css('min-height', ("calc(100vh - 170px - 40px - {footerBoxH}px - 1px)").replace("{footerBoxH}", footerBoxH));
      $('.wrapper-category .main > .box').css('min-height', ("calc(100vh - 170px - 11.496vw - {footerBoxH}px - 1px)").replace("{footerBoxH}", footerBoxH));
    }else{
      $('.main > .box').css('min-height', ("calc(100vh - 170px - 40px - {footerBoxH}px - 1px)").replace("{footerBoxH}", footerBoxH));
      $('.wrapper-category .main > .box').css('min-height', ("calc(100vh - 170px - 140px - {footerBoxH}px - 1px)").replace("{footerBoxH}", footerBoxH));
    }
  }
  mainBoxH();
  $(window).resize(mainBoxH);
  
  if($(window).innerWidth() < 767){
    entranceFooterBox.css('bottom',-footerBoxH-1+3);
    $(window).scroll(function(){
      if($(this).scrollTop() < document.body.scrollHeight-window.screen.availHeight+fixedBottomBoxH*2.5+4-footerBoxH){
        $('body').removeClass('switch');
        entranceFixedBottomBox.removeClass('position-relative');
        entranceFixedBottomBox.css('bottom',3);
        entranceFooterBox.removeClass('position-relative');
        entranceFooterBox.css('bottom',-footerBoxH-1+3);
      }else{
        $('body').addClass('switch');
        entranceFixedBottomBox.addClass('position-relative');
        entranceFixedBottomBox.css('bottom','inherit');
        entranceFooterBox.addClass('position-relative');
        entranceFooterBox.css('bottom','inherit');
      }
    });
  }
});

//float-box + trial-result-box
export function floatBox() {
  $('.float-box .toggle-btn').click(function(){
    $('.float-box').toggleClass('on');
    $('.float-box .function-3').attr('aria-pressed',false);
    $('.float-box .function-3').removeClass('active');
  });

  function floatBox() {
    if($(window).innerWidth() < 575){
      $(window).scroll(function(){
        if($(this).scrollTop()> 14 && $(this).scrollTop()< 129){
          $('#float-box > div').removeClass('position-fixed');
          $('#float-box-1 > div').addClass('position-fixed');
        }else if($(this).scrollTop()> 130){
          $('#float-box > div').addClass('position-fixed');
          $('#float-box-1 > div').addClass('position-fixed');
        }else{
          $('#float-box > div').removeClass('position-fixed');
          $('#float-box-1 > div').removeClass('position-fixed');
        }
      });
    }else if($(window).innerWidth() > 576 && $(window).innerWidth() < 767){
      $(window).scroll(function(){
        if($(this).scrollTop()> 14 && $(this).scrollTop()< 149){
          $('#float-box > div').removeClass('position-fixed');
          $('#float-box-1 > div').addClass('position-fixed');
        }else if($(this).scrollTop()> 149){
          $('#float-box > div').addClass('position-fixed');
          $('#float-box-1 > div').addClass('position-fixed');
        }else{
          $('#float-box > div').removeClass('position-fixed');
          $('#float-box-1 > div').removeClass('position-fixed');
        }
      });
    }else if($(window).innerWidth() > 768 && $(window).innerWidth() < 991){
      $(window).scroll(function(){
        if($(this).scrollTop()> 14){
          $('#float-box > div').addClass('position-fixed');
          $('#float-box-1 > div').addClass('position-fixed');
        }else{
          $('#float-box > div').removeClass('position-fixed');
          $('#float-box-1 > div').removeClass('position-fixed');
        }
      });
    }else if($(window).innerWidth() > 992 && $(window).innerWidth() < 1089){
      $(window).scroll(function(){
        if($(this).scrollTop()> 60){
          $('#float-box > div').addClass('position-fixed');
          $('#float-box-1 > div').addClass('position-fixed');
        }else{
          $('#float-box > div').removeClass('position-fixed');
          $('#float-box-1 > div').removeClass('position-fixed');
        }
      });
    }else{
      $(window).scroll(function(){
        if($(this).scrollTop()> 130 && $(this).scrollTop()< 255){
          $('#float-box > div').removeClass('position-fixed');
          $('#float-box-1 > div').addClass('position-fixed');
        }else if($(this).scrollTop()> 256){
          $('#float-box > div').addClass('position-fixed');
          $('#float-box-1 > div').addClass('position-fixed');
        }else{
          $('#float-box > div').removeClass('position-fixed');
          $('#float-box-1 > div').removeClass('position-fixed');
        }
      });
    }
  }

  function floatBox2() {
    var bannerBoxH = $('#banner-box').height();
    if($(window).innerWidth()> 768 && $(window).innerWidth() < 1419){
      $(window).scroll(function(){
        if($(this).scrollTop()> bannerBoxH-20){
          $('#float-box-2 > div').addClass('position-fixed');
        }else{
          $('#float-box-2 > div').removeClass('position-fixed');
        }
      });
    }else{
      $(window).scroll(function(){
        if($(this).scrollTop()> bannerBoxH+75){
          $('#float-box-2 > div').addClass('position-fixed');
        }else{
          $('#float-box-2 > div').removeClass('position-fixed');
        }
      });
    }
  }
  floatBox();
  floatBox2();
  $(window).resize(floatBox);
  $(window).resize(floatBox2);
}

$(function(){
    'use strict';
    floatBox();
});

//修正inline-block元素間空白
//$('.removeNodes').contents().filter(function() {
//  return this.nodeType === 3;
//}).remove();

$(function(){
	'use strict';
	$("a.nav-link").click(function(){
        var $modalRoot = $(this).closest("div.modal");
        if($modalRoot.length == 1){
            var $allTitleDiv = $modalRoot.find("a.nav-link").find("div:first");
            $allTitleDiv.removeClass("navs-title");
            $allTitleDiv.removeClass("title");
            $allTitleDiv.addClass("title");
        }

        var $titleDiv = $(this).find("div:first");
        $titleDiv.removeClass("title");
        $titleDiv.addClass("navs-title");
	});
});

export default {
floatBox:floatBox
}